module.exports = __webpack_public_path__ + "img/orange_124.26080809.png";